import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconCategoryDesign({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M9.428 7.456a.494.494 0 0 1 .158.974c-.59.096-1.181.157-1.772.186.097 1.104.35 2.175.745 3.216a.493.493 0 0 1-.922.35A13.213 13.213 0 0 1 7 9.927a13.215 13.215 0 0 1-.637 2.255.493.493 0 0 1-.922-.35 11.97 11.97 0 0 0 .746-3.218c-.59-.03-1.18-.092-1.77-.184a.494.494 0 0 1 .152-.974c1.62.253 3.24.263 4.859 0zM7 5.5a.89.89 0 1 1 0 1.78.89.89 0 0 1 0-1.78z"/>
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M12 1.5A2.5 2.5 0 0 1 14.5 4v6c0 1.225-.881 2.24-2.044 2.455A2.499 2.499 0 0 1 10 14.5H4A2.5 2.5 0 0 1 1.5 12V6c0-1.244.91-2.274 2.1-2.466l-.057.009A2.5 2.5 0 0 1 6 1.5h6zm-8 3A1.5 1.5 0 0 0 2.5 6v6A1.5 1.5 0 0 0 4 13.5h6a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 10 4.5H4zm2-2a1.5 1.5 0 0 0-1.413 1H10A2.5 2.5 0 0 1 12.5 6v5.412c.582-.206 1-.76 1-1.412V4A1.5 1.5 0 0 0 12 2.5H6z"/>
        </svg>

    );
}

export default IconCategoryDesign;

